import { get, post } from './api';

export const getCategoryList = function(topCode) {
    return get('/search/category/childList', { topCode });
};

export const getBrandList = function(params) {
    return post('/index/queryBrandList', params);
};

export const goodsListByCategory = function(params) {
    return post('/index/queryGoodsList', params);
};

export const getQqList = function() {
    return get('/config/qqList');
};

export const getProductList = function(type, page, pageSize) {
    return get('/search/product/listByType', { type, page, pageSize });
};

export const getFeaturedList = function(limit, type) {
    return get('/search/product/getFeaturedList', { limit, type });
};

export const getNavList = function(params) {
    return post('/index/queryGoodsCategoryTreeList', params);
};

export const articleList = function(params) {
    return post('/article/queryList', params);
};

export const artInfo = function(params) {
    return post('/article/getById?id=' + params.id);
};

// setting集合查询
export const querySettingSimpleList = function() {
    return post('/crm/querySettingSimpleList', {});
};

// banner集合查询
export const queryBannerSimpleList = function () {
    return post('/crm/queryBannerSimpleList', {});
};

// setting集合查询
export const setList = function () {
    return post('/crm/querySettingSimpleList', {});
};